import moment from 'moment'
import { API } from './core'
import { AccountKey } from './account'
import { CategoryKey } from './category'

export const ReviewStatus = [
  { text: 'Created', value: 'Created' },
  { text: 'Reviewed', value: 'Reviewed' },
  { text: 'Booked', value: 'Booked' },
  { text: 'TBD', value: 'TBD' }
]

export class TransactionFilter {
  constructor (params = {}) {
    this.account = params.account || null
    this.category = params.category || null
    this.tags = params.tags || []
    this.start = params.start || null
    this.end = params.end || null
    this.limit = params.limit || null
    this.review_status = params.review_status || null
    this.only_reportable = params.only_reportable === undefined ? null : params.only_reportable
    this.orderby = params.orderby || []
    this.title = params.title || null
  }

  clone () {
    let filter = new TransactionFilter()
    const raw = JSON.parse(JSON.stringify(this))
    filter = Object.assign(filter, raw)
    return filter
  }

  update (newParams) {
    Object.keys(newParams).forEach((key) => {
      this[key] = newParams[key]
    })
  }

  saveToCache () {
    const raw = JSON.stringify(this)
    window.localStorage.setItem('rza_filters', raw)
  }

  static fromCache () {
    let filter = new TransactionFilter()
    let raw = window.localStorage.getItem('rza_filters')
    if (raw) {
      raw = JSON.parse(raw)
      filter = Object.assign(filter, raw)
    }
    return filter
  }
}

export class TransactionAggregation {
  static createFromJson (raw) {
    let obj = new TransactionAggregation()
    obj = Object.assign(obj, raw)
    obj.category = new CategoryKey(raw._id)
    return obj
  }
}

export class Transaction {
  reset () {
    let at = new Date()
    let atm = moment(at)
    this.date = atm.format('YYYY-M-D')
    this.time = atm.format('HH:mm')
    this.narration = ''
    this.amount = null
    this.account = null
    this.category = null
    this.note = null
    this.tags = []
    this.currency = null
    this.org_notes = null
  }
  prepareSaveData () {
    const params = this.prepareEditCatData()
    let at = moment.utc(`${this.date} ${this.time}`, 'YYYY-M-D HH:mm').toISOString(true)

    if (this.account && this.account.currency && !this.currency) {
      this.currency = this.account.currency
    }
    
    params['at'] = at
    params['amount'] = this.amount
    params['currency'] = this.currency
    params['org_notes'] = this.org_notes
    return params
  }
  prepareEditCatData () {
    let tagNames = []
    if (this.tags) {
      this.tags.forEach((tag) => {
        if (tag.name) {
          tagNames.push(tag.name)
        } else if (tag) {
          tagNames.push(tag)
        }
      })
    }
    return {
      'narration': this.narration,
      'notes': this.notes,
      'review_status': this.review_status,
      'account': this.account.key,
      'category': (this.category) ? this.category.key : null,
      'tags': tagNames
    }
  }
  create () {
    return API.instance().put('/transaction/', this.prepareSaveData()).then((resp) => {
      const coverage = Transaction.createFromJson(resp.data.data.data)
      return coverage
    })
  }
  save () {
    return API.instance().post(`/transaction/${this.key}/`, this.prepareSaveData()).then((resp) => {
      const coverage = Transaction.createFromJson(resp.data.data.data)
      return coverage
    })
  }
  editCat () {
    return API.instance().post(`/transaction/${this.key}/catedit/`, this.prepareEditCatData()).then((resp) => {
      const data = Transaction.createFromJson(resp.data.data.data)
      return data
    })
  }
  markReviewed () {
    this.review_status = 'Reviewed'
    return API.instance().post(`/transaction/${this.key}/catedit/`, this.prepareEditCatData()).then((resp) => {
      const data = Transaction.createFromJson(resp.data.data.data)
      return data
    })
  }
  static newEmpty () {
    let transaction = new Transaction()
    transaction.reset()
    return transaction
  }
  static createFromJson (raw) {
    let transaction = Transaction.newEmpty()
    transaction = Object.assign(transaction, raw)
    transaction.account = new AccountKey(transaction.account)
    transaction.category = new CategoryKey(transaction.category)
    if (transaction.tags) {
      transaction.tags = transaction.tags.sort()
    }
    return transaction
  }
  static list (params) {
    return API.instance().get('/transaction/', { params }).then((resp) => {
      const data = resp.data.data.data.map((raw) => Transaction.createFromJson(raw))
      const aggregation = resp.data.data.aggregation.map((raw) => TransactionAggregation.createFromJson(raw))
      return { transactions: data, aggregation, cursor: resp.data.data.cursor }
    })
  }
  static report (params) {
    return API.instance().get('/transaction/report/', { params }).then((resp) => {
      const { cursor } = resp.data.data
      const reportItems = resp.data.data.report.map((raw) => TransactionAggregation.createFromJson(raw))
      return { cursor, reportItems }
    })
  }
  static categoryReportTable (filters) {
    const requests = []
    const results = new Array(filters.length).fill(null)
    filters.forEach((params, i) => {
      requests.push(
        this.report(params).then((result) => {
          results[i] = result
        })
      )
    })

    const values = {}
    const items = []
    return Promise.all(requests).then(() => {
      results.forEach((result, i) => {
        result.reportItems.forEach((item) => {
          const key = item.category.key
          if (!values[key]) {
            values[key] = new Array(results.length).fill(0)
            items.push(item)
          }
          values[key][i] = item.sum
        })
      })

      const rows = []
      items.forEach((item) => {
        const key = item.category.key
        const col = {
          category: item.category
        }
        values[key].forEach((sum, i) => {
          col[`price_${i}`] = sum
        })

        rows.push(col)
      })

      return {
        filters,
        items,
        values,
        results,
        rows
      }
    })
  }
}
